'use client';
import { DateFormatOptions, formatDate } from '@/lib/utils';
import { useSyncExternalStore } from 'react';

// The server renders in UTC, which can land on the wrong day and never matches the browser. Server
// and hydration render in this fixed zone instead, then the browser switches to the viewer's own.
const SERVER_TIME_ZONE = 'America/New_York';

const subscribe = () => () => {};

type TimeLocalProps = {
	timestamp: string;
	className?: string;
	options?: DateFormatOptions;
};

const TimeLocal = ({ timestamp, className, options }: TimeLocalProps) => {
	const isClient = useSyncExternalStore(
		subscribe,
		() => true,
		() => false,
	);
	const formatted = formatDate(timestamp, {
		...(options ?? {
			weekday: 'short',
			month: 'short',
			day: 'ordinal',
			time: true,
			timeZoneName: true,
		}),
		timeZone: isClient ? undefined : SERVER_TIME_ZONE,
	});

	return (
		<time dateTime={timestamp} className={className}>
			{formatted}
		</time>
	);
};

export default TimeLocal;
